// TODO: Refactor to use MUI theme overrides instead of !important
// The !important declarations are needed to override MUI's high-specificity pseudo-class styles
// Consider moving these to theme.components overrides or using styled() with higher specificity
export const commonInputStyles = {
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#337abb !important"
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#337abb !important",
    borderWidth: "2px !important"
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#337abb !important",
    borderWidth: "4px !important"
  },
  "&:focus .MuiOutlinedInput-notchedOutline": {
    borderColor: "#337abb !important",
    borderWidth: "4px !important"
  },
  "&:focus-within .MuiOutlinedInput-notchedOutline": {
    borderColor: "#337abb !important",
    borderWidth: "4px !important"
  },
  "&.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important"
  },
  "&.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important",
    borderWidth: "4px !important"
  },
  "&:focus.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important",
    borderWidth: "4px !important"
  },
  "&:focus-within.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important",
    borderWidth: "4px !important"
  },
  "&:hover.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important",
    borderWidth: "2px !important"
  },
  "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important"
  },
  "& .MuiOutlinedInput-root.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important",
    borderWidth: "2px !important"
  },
  "& .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline":
    {
      borderColor: "#b3261e !important",
      borderWidth: "4px !important"
    },
  "& .MuiOutlinedInput-root.Mui-error:focus .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important",
    borderWidth: "4px !important"
  },
  "& .MuiOutlinedInput-root.Mui-error:focus-within .MuiOutlinedInput-notchedOutline":
    {
      borderColor: "#b3261e !important",
      borderWidth: "4px !important"
    },
  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d3d3d3 !important",
    borderWidth: "1px !important"
  },
  "&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d3d3d3 !important",
    borderWidth: "1px !important"
  },
  "&.Mui-disabled.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d3d3d3 !important",
    borderWidth: "1px !important"
  },
  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important"
  },
  "& .MuiOutlinedInput-root.Mui-disabled:hover .MuiOutlinedInput-notchedOutline":
    {
      borderWidth: "1px !important"
    },
  "& .MuiOutlinedInput-root.Mui-disabled.Mui-focused .MuiOutlinedInput-notchedOutline":
    {
      borderWidth: "1px !important"
    },
  "& .MuiOutlinedInput-input": {
    padding: "0.7rem",
    fontSize: "1rem",
    "&::placeholder": {
      color: "#767676"
    }
  }
};

export const selectStyles = {
  ...commonInputStyles,
  "& .MuiSvgIcon-root": {
    color: "#337abb"
  },
  "& .MuiSelect-select": {
    padding: "0.7rem !important",
    fontSize: "1rem"
  }
};

export const getSelectStyles = hasError => ({
  "& .MuiSvgIcon-root": {
    color: hasError ? "#b3261e" : "#337abb"
  },
  "& .MuiSelect-select": {
    padding: "0.7rem !important",
    fontSize: "1rem"
  },
  "& .MuiOutlinedInput-notchedOutline": {
    "& legend": {
      maxWidth: "100%"
    }
  },
  ...commonInputStyles,
  ...(hasError && {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important",
      borderWidth: "2px !important"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important",
      borderWidth: "2px !important"
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important"
    }
  }),
  "@media (max-width: 640px)": {
    "& fieldset": {
      margin: "0 !important"
    }
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: hasError ? "#b3261e !important" : "#337abb !important",
    borderWidth: "4px !important"
  },
  "&:focus .MuiOutlinedInput-notchedOutline": {
    borderColor: hasError ? "#b3261e !important" : "#337abb !important",
    borderWidth: "4px !important"
  },
  "&:focus-within .MuiOutlinedInput-notchedOutline": {
    borderColor: hasError ? "#b3261e !important" : "#337abb !important",
    borderWidth: "4px !important"
  }
});

export const textFieldStyles = {
  ...commonInputStyles
};

export const readOnlyTextFieldStyles = {
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#337abb !important",
    borderWidth: "1px !important"
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#337abb !important",
    borderWidth: "1px !important"
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#337abb !important",
    borderWidth: "1px !important"
  },
  "&.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important",
    borderWidth: "1px !important"
  },
  "&.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important",
    borderWidth: "1px !important"
  },
  "&:hover.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#b3261e !important",
    borderWidth: "1px !important"
  },
  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d3d3d3 !important",
    borderWidth: "1px !important"
  },
  "&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d3d3d3 !important",
    borderWidth: "1px !important"
  },
  "&.Mui-disabled.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d3d3d3 !important",
    borderWidth: "1px !important"
  },
  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important"
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important"
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important"
  },
  "& .MuiOutlinedInput-input": {
    padding: "0.7rem",
    fontSize: "1rem",
    "&::placeholder": {
      color: "#767676"
    }
  },
  "@media (max-width: 640px)": {
    "& fieldset": {
      margin: "0 !important"
    }
  }
};

export const getTextFieldStyles = hasError => ({
  ...commonInputStyles,
  ...(hasError && {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important",
      borderWidth: "2px !important"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important",
      borderWidth: "2px !important"
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important"
    }
  }),
  "@media (max-width: 640px)": {
    "& fieldset": {
      margin: "0 !important"
    }
  }
});

export const labelStyles = {
  fontSize: "0.875rem",
  fontWeight: 400,
  color: "#333333"
};

export const formControlStyles = {
  width: "100%",
  margin: "0 !important"
};

export const helperTextStyles = {
  color: "#b3261e",
  fontSize: "0.75rem"
};

export const getAutocompleteStyles = hasError => ({
  ...commonInputStyles,
  "& .MuiSvgIcon-root": {
    color: "#337abb"
  },
  "& .MuiOutlinedInput-input": {
    padding: "0.7rem",
    fontSize: "1rem",
    "&::placeholder": {
      color: "#767676"
    }
  },
  "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
    padding: "0.7rem !important"
  },
  "& .MuiOutlinedInput-root": {
    padding: "0 !important",
    "&:focus .MuiOutlinedInput-notchedOutline": {
      borderColor: hasError ? "#b3261e !important" : "#337abb !important",
      borderWidth: "4px !important"
    },
    "&:focus-within .MuiOutlinedInput-notchedOutline": {
      borderColor: hasError ? "#b3261e !important" : "#337abb !important",
      borderWidth: "4px !important"
    }
  },
  ...(hasError && {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important",
      borderWidth: "2px !important"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important",
      borderWidth: "2px !important"
    },
    "& .MuiOutlinedInput-root:focus .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important",
      borderWidth: "4px !important"
    },
    "& .MuiOutlinedInput-root:focus-within .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b3261e !important",
      borderWidth: "4px !important"
    }
  }),
  "@media (max-width: 640px)": {
    "& fieldset": {
      margin: "0 !important"
    }
  }
});
